import React from "react";

const Divider = (props) => {
    return (
        <div className={`divider ${props.className}`} style={props.style ?? {}}></div>
    )
}

export default Divider;